import { defineMessages } from "react-intl";

export const messages = defineMessages({
  undefined: {
    id: "desc_item_undefined",
    defaultMessage: "Výjimka",
  },
});
